import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { VueCookieNext } from "vue-cookie-next";
async function initVisitorId() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  const visitorId = result.visitorId;
  return visitorId
}
export async function getVisitorId() {
  let visitorId = VueCookieNext.getCookie('clientID');
  const uuid = VueCookieNext.getCookie('uuid');
  if(!visitorId){
    visitorId = await initVisitorId();
    if(!visitorId){
      visitorId = uuid;
    }
    VueCookieNext.setCookie('clientID', visitorId );
  }
  return visitorId;
}